import React from 'react';
import { Link } from 'react-router-dom';

const DataPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Data Policy</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. How to Delete Your Data</h2>
              <p className="text-gray-700 mb-4">
                If you're a <strong>MyDocIT USER</strong> and wish to delete your data, follow the steps below:
              </p>
              
              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
                <h3 className="text-lg font-medium text-blue-900 mb-2">To delete your account and all associated data from the MyDocIT database, please:</h3>
                <ol className="list-decimal list-inside text-blue-800 space-y-2">
                  <li>Send an email to <strong>appsdesignservices@gmail.com</strong> with the subject line: <strong>"DELETE MY ACCOUNT"</strong>.</li>
                  <li>Include the following in your email:
                    <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                      <li>Your registered email address</li>
                      <li>Your phone number</li>
                      <li>Your full name</li>
                    </ul>
                  </li>
                  <li>You will receive a confirmation email once your account has been deleted.</li>
                </ol>
              </div>
              
              <div className="bg-red-50 border-l-4 border-red-400 p-4">
                <p className="text-red-800 font-medium">
                  <strong>Please note:</strong> Your data cannot be recovered once deletion is complete.
                </p>
              </div>
            </section>

            {/* <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. What Data Will Be Deleted</h2>
              <p className="text-gray-700 mb-4">
                When you request account deletion, the following data will be permanently removed from our systems:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Personal information (name, email, phone number, address)</li>
                <li>Medical records and health data</li>
                <li>Appointment history and scheduling information</li>
                <li>Medication records and prescriptions</li>
                <li>Test results and laboratory data</li>
                <li>Vital signs and health metrics</li>
                <li>Diet and lifestyle information</li>
                <li>Account preferences and settings</li>
                <li>Notification history and preferences</li>
                <li>Payment and billing information</li>
              </ul>
            </section> */}

            {/* <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Data Retention Exceptions</h2>
              <p className="text-gray-700 mb-4">
                Some data may be retained for legal or regulatory purposes, including:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Records required for legal compliance (e.g., healthcare regulations)</li>
                <li>Data needed for ongoing legal proceedings</li>
                <li>Information required for fraud prevention and security</li>
                <li>Anonymized data used for research and analytics</li>
              </ul>
            </section> */}

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Processing Time</h2>
              <p className="text-gray-700 mb-4">
                Account deletion requests are typically processed within:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li><strong>30 days</strong> for standard account deletion</li>
                <li><strong>90 days</strong> for accounts with complex data or legal requirements</li>
              </ul>
              <p className="text-gray-700 mt-4">
                You will receive regular updates on the status of your deletion request.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Data Export</h2>
              <p className="text-gray-700 mb-4">
                Before deleting your account, you may request a copy of all your data:
              </p>
              <div className="bg-green-50 border-l-4 border-green-400 p-4">
                <p className="text-green-800">
                  Send an email to <strong>appsdesignservices@gmail.com</strong> with the subject line: <strong>"EXPORT MY DATA"</strong> to receive a complete copy of your information.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Third-Party Data</h2>
              <p className="text-gray-700 mb-4">
                Please note that we cannot delete data that has been shared with:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Healthcare providers and medical facilities</li>
                <li>Insurance companies (if applicable)</li>
                <li>Government agencies (for regulatory compliance)</li>
                <li>Third-party service providers (as required by our agreements)</li>
              </ul>
              <p className="text-gray-700 mt-4">
                You may need to contact these entities directly to request data deletion from their systems.
              </p>
            </section>

            {/* <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Contact Information</h2>
              <p className="text-gray-700 mb-4">
                For questions about data deletion or this policy, please contact us:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  <strong>Email:</strong> privacy@mydocit.com<br />
                  <strong>Phone:</strong> +1 (555) 123-4567<br />
                  <strong>Address:</strong> 123 Healthcare Street, Medical District, Jamaica<br />
                  <strong>Response Time:</strong> Within 48 hours
                </p>
              </div>
            </section> */}

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Updates to This Policy</h2>
              <p className="text-gray-700">
                We may update this Data Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date. We encourage you to review this policy periodically.
              </p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center space-x-4">
            <Link 
              to="/login" 
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Back to Login
            </Link>
            <Link 
              to="/privacypolicy" 
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataPolicy; 